/**
 * Key for local storage of cart items
 */
export const LOCAL_CART_KEY = 'pd_checkout';
